export const newsConstants = {
  HOME_NEWS_REQUEST: 'HOME_NEWS_REQUEST',
  HOME_NEWS_SUCCESS: 'HOME_NEWS_SUCCESS',
  HOME_NEWS_FAILURE: 'HOME_NEWS_FAILURE',

  SINGLE_NEWS_REQUEST: 'SINGLE_NEWS_REQUEST',
  SINGLE_NEWS_SUCCESS: 'SINGLE_NEWS_SUCCESS',
  SINGLE_NEWS_FAILURE: 'SINGLE_NEWS_FAILURE'
};
